import { useEffect } from 'react';

export const useSpaceBackground = () => {
  useEffect(() => {
    const createSpaceBackground = () => {
      const starsContainer = document.getElementById('starsContainer');
      if (!starsContainer) return;
      
      const starCount = window.innerWidth < 768 ? 100 : 150;

      // Clear existing stars
      starsContainer.innerHTML = '';

      // Create regular stars
      for (let i = 0; i < starCount; i++) {
        const star = document.createElement('div');
        star.className = 'star';
        
        const rand = Math.random();
        if (rand < 0.6) {
          star.classList.add('small');
        } else if (rand < 0.85) {
          star.classList.add('medium');
        } else {
          star.classList.add('large');
        }
        
        star.style.left = Math.random() * 100 + '%';
        star.style.top = Math.random() * 100 + '%';
        star.style.animationDelay = Math.random() * 3 + 's';
        star.style.animationDuration = (Math.random() * 2 + 2) + 's';
        
        starsContainer.appendChild(star);
      }

      // Create shooting stars
      const shootingStarCount = window.innerWidth < 768 ? 2 : 4;
      for (let i = 0; i < shootingStarCount; i++) {
        const shootingStar = document.createElement('div');
        shootingStar.className = 'shooting-star';
        shootingStar.style.top = Math.random() * 50 + '%';
        shootingStar.style.animationDelay = Math.random() * 6 + 's';
        shootingStar.style.animationDuration = (Math.random() * 2 + 3) + 's';
        starsContainer.appendChild(shootingStar);
      }
    };

    // Make refresh function globally available for theme changes
    window.refreshStarsForTheme = () => {
      setTimeout(() => {
        createSpaceBackground();
      }, 100);
    };

    createSpaceBackground();

    const handleResize = () => {
      createSpaceBackground();
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
};